export function safeInit(name, func) {
  try {
    func();
  } catch (e) {
    console.error("[PDP] Error during initialization of [".concat(name, "]"), e);
  }
}